import RegistrationType from "../types/registrationType";

interface RegistrationAction {
  type: string;
  payload?: any;
}

const initial_state = {
  registrationList: [],
  sellerProfileData: null,
  referralList: [],
  currentPage: 0,
  lastPage: 0,
  totalData: 0,
  from: 0,
  to: 0,
  bsList: [],
  myBuyerList: [],
  bsRequestList: [],
  buyerRequestList: [],
};
const RegistrationReducer = (
  state = initial_state,
  action: RegistrationAction
) => {
  switch (action.type) {
    case RegistrationType.SET_REG_LIST:
      return {
        ...state,
        registrationList: action.payload,
      };

    case RegistrationType.SET_SELLER_PROFILE:
      return {
        ...state,
        sellerProfileData: action.payload,
      };

    case RegistrationType.SET_REFERRAL_LIST:
      return {
        ...state,
        referralList: action.payload.data,
        currentPage: action.payload.currentPage,
        lastPage: action.payload.lastPage,
        totalData: action.payload.totalData,
        from: action.payload.from,
        to: action.payload.to,
      };

    case RegistrationType.BS_LIST:
      return {
        ...state,
        bsList: action.payload,
      };

    case RegistrationType.MY_BUYER_LISTY:
      return {
        ...state,
        myBuyerList: action.payload,
      };

    case RegistrationType.SET_BS_REQUESTR_LIST:
      return {
        ...state,
        bsRequestList: action.payload.data,
        currentPage: action.payload.currentPage,
        lastPage: action.payload.lastPage,
        totalData: action.payload.totalData,
        from: action.payload.from,
        to: action.payload.to,
      };

    case RegistrationType.BS_SEND_REQUEST:
      return {
        ...state,
      };

    case RegistrationType.SET_BUYER_REQUESTR_LIST:
      return {
        ...state,
        buyerRequestList: action.payload.data,
        currentPage: action.payload.currentPage,
        lastPage: action.payload.lastPage,
        totalData: action.payload.totalData,
        from: action.payload.from,
        to: action.payload.to,
      };

    case RegistrationType.BS_REQUEST_ACCEPT_REJECT:
      return {
        ...state,
      };

    default:
      return state;
  }
};

export default RegistrationReducer;
